import React, {useEffect, useState} from 'react';
import Select from "../../common/primitives/Select";

import styles from './ComponentTLDTable.scss';
import Price from "../../common/primitives/Price";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import {_scrollToLeft} from "../../common/helpers/HelperAnimation";
import DomainLabelNew from "../../common/primitives/DomainLabelNew";
import {__t} from '../../common/lang/text-resource';

/**
 *
 * @param {TLDData} tldData
 * @returns {string}
 */
function getTLDCodeAnchor(tldData) {

	const tldAnchorMap = {
		eu: '/domain-eu.php',
		bg: '/domain-bg.php',
		bgcyr: '/domain-bg-cyrillic.php',
	};
	if (tldAnchorMap[tldData.id]) {
		return <a href={tldAnchorMap[tldData.id]}>.{tldData.code}</a>;
	}
	if (tldData.has_special_page) {
		return <a href={`/newdomain-${tldData.id}.php`}>.{tldData.code}</a>;
	}

	return `.${tldData.code}`
}

/**
 *
 * @param {TLDData} tldData
 * @returns {Array<DomainLabelNew>}
 */
function getTLDTags(tldData) {
	let domainLabels = [];

	if (tldData.labels.length > 0) {

		/** @type TLDLabelData label La*/
		tldData.labels.map((label, key) => {
			domainLabels.push(<DomainLabelNew
			  textColor={`#${label.text_color}`}
			  text={label.name}
			  key={key}
			  backgroundColor={`#${label.background_color}`}/>)
		});
	}
	return domainLabels;
}

function tldsTableInViewport() {
	const el = document.getElementById('js-tlds-table-container');
	const rect = el.getBoundingClientRect();
	const elemTop = rect.top;
	const elemBottom = rect.bottom;

	// Only completely visible elements return true:
	// const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
	// Partially visible elements return true:
	const isVisible = elemTop < (window.innerHeight / 2) && elemBottom >= 0;
	if (isVisible && el.scrollLeft > 0) {
		_scrollToLeft(el, el.scrollLeft, 0.3);
	}
}

export default function ComponentTLDTable({
											  tldData,
											  categories,
											  isMobile,
											  allTags,
											  defaultTag,
											  defaultCategory,
											  promotions
										  }) {

	const categoriesSelect = categories;

	const [selectedCategory, setCategory] = useState(defaultCategory);
	const [selectedTag, setTag] = useState(defaultTag);

	const handleCategoryChange = (selected) => {
		window.location.hash = selected.anchor;
		setCategory(selected)
	};

	const handleTagChange = (tag) => {
		window.location.hash = tag.anchor;
		setTag(tag)
	};

	const tlds = Object.values(tldData[selectedCategory.value]);

	let tldTOShow = [];
	if (selectedCategory.anchor === 'new-domains') {
		tldTOShow = tlds.filter((tld) => tld.tags.includes(selectedTag.id));
	} else {
		tldTOShow = tlds;
	}

	tlds.sort((a, b) => (a.category_order > b.category_order) ? 1 : -1);

	if (tldTOShow !== undefined && tldTOShow != '') {
		if (selectedCategory.value == 'all') {
			tldTOShow.sort((a, b) => (a.priority > b.priority) ? 1 : -1);
		} else {
			tldTOShow.sort((a, b) => (a.priority_cat > b.priority_cat) ? 1 : -1);
		}
	}

	useEffect(() => {
		document.getElementById('js-tlds-table-container').scrollLeft = document.getElementById('js-tlds-table').scrollWidth;
		window.addEventListener("scroll", tldsTableInViewport);
		return () => {
			window.removeEventListener("scroll", tldsTableInViewport);
		};
	}, []);


	return (
	  <div>
		  <div className={styles.tldComboContainer}>
			  {
				  isMobile ?
					<div className={styles.selectContainer}>
						<Select
						  name='tld_category'
						  options={categoriesSelect}
						  selected={selectedCategory.value}
						  onChange={handleCategoryChange}/>
					</div>
					: <div>
						<ul className={styles.categoriesList}>
							{
								categoriesSelect.map((category, key) => <li key={key}
																			className={category.value === selectedCategory.value ? styles.active : ''}>
									<Button
									  onClick={() => handleCategoryChange(category)}
									  name={`toggle_category_${category.value}`}
									  value={category.label.charAt(0).toUpperCase() + category.label.slice(1)}
									  className={`${buttons.buttonLink} ${buttons.action}`}/>
								</li>)
							}
						</ul>
					</div>
			  }
		  </div>
		  {
			selectedCategory.anchor === 'new-domains' &&
			<ul className={styles.tags}>
				{


					allTags.map((tag, key) => {
						return <li key={key} className={selectedTag.id === tag.id ? styles.active : ''}>
							<Button
							  onClick={() => handleTagChange(tag)}
							  name={`set_tag_${tag.id}`}
							  value={tag.name}
							  className={`${buttons.buttonLink} ${buttons.action}`}/>
						</li>
					})
				}
			</ul>
		  }
		  <div className={styles.tableContainer} id='js-tlds-table-container'>
			  <table id='js-tlds-table'>
				  <thead>
				  <tr>
					  <th>{__t('домейн')}</th>
					  <th><span data-layout="hide show@md">{__t('цена за')} </span>{__t('регистрация')}</th>
					  <th><span data-layout="hide show@md">{__t('цена за')} </span>{__t('трансфер')}</th>
					  <th><span data-layout="hide show@md">{__t('цена за')} </span>{__t('подновяване')}</th>
					  <th><span data-layout="hide show@md">{__t('минимален')} </span>{__t('период')}</th>
				  </tr>
				  </thead>
				  <tbody>
				  {
					  tldTOShow.map((tld, key) => {
							return (
							  <tr key={key}>
								  <td>
									  {getTLDCodeAnchor(tld)}
									  {
										  (tld.id === 'us' || tld.id === 'xxx') ? '*' : ''
									  }
									  <div data-layout="hide show@md">
										  {getTLDTags(tld)}
									  </div>
								  </td>
								  <td>
									  {
										  <div className={styles.priceGroup}>
											  <div className={styles.price}>
												  <Price
													value={tld.prices.priceNew}
													currency={tld.prices.currency}
													currencyClass={styles.priceCurrency}/>
											  </div>
											  {
												parseFloat(tld.prices.priceNew) < parseFloat(tld.prices.basePriceNew) &&
												<div className={styles.priceOld}>
													<Price
													  value={tld.prices.basePriceNew}
													  currency={tld.prices.currency}/>
												</div>
											  }
										  </div>
									  }
									  {SHVO.showEuroPrices && <>
										  <div className={styles.priceGroup}>
											  <div className={styles.price}>
												  <Price
													value={tld.prices.priceNewEUR}
													currency={tld.prices.currencyEUR}
													currencyClass={styles.priceCurrency}/>
											  </div>
											  {
												parseFloat(tld.prices.priceNew) < parseFloat(tld.prices.basePriceNew) &&
												<div className={styles.priceOld}>
													<Price
													  value={tld.prices.basePriceNewEUR}
													  currency={tld.prices.currencyEUR}/>
												</div>
											  }
										  </div>
									  </>}
								  </td>
								  <td>

									  {
										  tld.transferable === true ? <div className={styles.priceGroup}>
											  <div className={styles.price}>
												  <Price
													value={tld.transferPrices.priceNew}
													currency={tld.transferPrices.currency}
													currencyClass={styles.priceCurrency}/>
											  </div>
											  {
												parseFloat(tld.transferPrices.priceNew) < parseFloat(tld.transferPrices.basePriceNew) &&
												<div className={styles.priceOld}>
													<Price
													  value={tld.transferPrices.basePriceNew}
													  currency={tld.transferPrices.currency}/>
												</div>
											  }
										  </div> : '-'
									  }
									  {SHVO.showEuroPrices && <>
										  {
											  tld.transferable === true ? <div className={styles.priceGroup}>
												  <div className={styles.price}>
													  <Price
														value={tld.transferPrices.priceNewEUR}
														currency={tld.transferPrices.currencyEUR}
														currencyClass={styles.priceCurrency}/>
												  </div>
												  {
													parseFloat(tld.transferPrices.priceNew) < parseFloat(tld.transferPrices.basePriceNew) &&
													<div className={styles.priceOld}>
														<Price
														  value={tld.transferPrices.basePriceNewEUR}
														  currency={tld.transferPrices.currencyEUR}/>
													</div>
												  }
											  </div> : ''
										  }
									</>}
								  </td>
								  <td>
									  {
										  tld.prices ?
											<div className={styles.priceGroup}>
												<div className={styles.price}>
													<Price
													  value={tld.prices.priceRenew}
													  currency={tld.prices.currency}
													  currencyClass={styles.priceCurrency}/>
												</div>
												{
												  parseFloat(tld.prices.priceRenew) < parseFloat(tld.prices.basePriceRenew) &&
												  <div className={styles.priceOld}>
													  <Price
														value={tld.prices.basePriceRenew}
														currency={tld.prices.currency}/>
												  </div>
												}
											</div> : '-'
									  }
									  {SHVO.showEuroPrices && <>
										  {
											  tld.prices ?
												<div className={styles.priceGroup}>
													<div className={styles.price}>
														<Price
														  value={tld.prices.priceRenewEUR}
														  currency={tld.prices.currencyEUR}
														  currencyClass={styles.priceCurrency}/>
													</div>
													{
													  parseFloat(tld.prices.priceRenew) < parseFloat(tld.prices.basePriceRenew) &&
													  <div className={styles.priceOld}>
														  <Price
															value={tld.prices.basePriceRenewEUR}
															currency={tld.prices.currencyEUR}/>
													  </div>
													}
												</div> : ''
										  }
									  </>}

								  </td>
								  <td>
									  {tld.prices ? tld.prices.term : '-'}
								  </td>
							  </tr>
							);
						}
					  )
				  }
				  </tbody>
			  </table>
		  </div>
	  </div>
	)
}
